export default {"src":"/_next/static/media/gelatindessert.1470d7e9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};